import { useEffect, useState } from "react";

export const useTopNavHeight = () => {

    const [topNavHeight, setTopNavHeight] = useState(0);
    const topNavElement = document.getElementById("top-nav");

    useEffect(() => {
        if (topNavElement) {
            setTopNavHeight(topNavElement.offsetHeight);
        }
    }, [topNavElement]);

    return topNavHeight;
}

